import { useContext } from "react";

import DesktopLayoutContext from "../context/DesktopLayoutContext";

export default function useDesktopLayout() {
    return useContext(DesktopLayoutContext);
}
